define('views/components/product_reseller_price/product_reseller_prices',['require','backbone','views/components/product_reseller_price/product_reseller_price','text!templates/components/product_reseller_price/product_reseller_prices.html'],function(require){
    var Backbone = require('backbone');

    var ChildView = require('views/components/product_reseller_price/product_reseller_price');

    var temp = require("text!templates/components/product_reseller_price/product_reseller_prices.html");
    return Backbone.Marionette.CompositeView.extend({
        tagName: 'div',
        template: _.template(temp),
        childView: ChildView,
        childViewContainer: '.row'
    });
});

